/*
  live-prices.js — dotahuje aktuální ceny do statického obsahu stránek.

  PROČ existuje: obsah /pages/* je uložený v `page.body_html` v Shopify, kde se
  NErenderuje Liquid. Ceny v kartách a carouselech se proto psaly ručně a při
  každé změně ceníku zastaraly (13. 8. 2026 jich bylo napříč webem 30+ špatně,
  např. Explorer 3000 V2 za 45 999 místo 39 999 Kč).

  JAK to funguje: skript najde cenové prvky, k nim dohledá produkt podle odkazu
  /products/<handle> ve stejné kartě a cenu přepíše hodnotou z Shopify.

  Cenu NIKDY nemění v obchodě — pouze zobrazuje tu, která u produktu skutečně je.

  Podchycení prvku (v tomto pořadí):
    1) [data-live-price="handle"]  — explicitní, pro případy mimo kartu
    2) .prod-price / .product-price / [data-price]  — handle se vezme z odkazu v kartě

  Formát čísla se přebírá z Shopify (moneyFormat), takže sedí i pro SK/HU/RO/SI trh.
*/
(function () {
  'use strict';

  var SEL = '[data-live-price], .prod-price, .product-price, [data-price]';
  var OWNED_ATTRIBUTE = 'data-live-price-owned';
  var CURRENCY_MARKERS = '(?:Kč|CZK|€|EUR|Ft|HUF|lei|RON)';
  var PRICE_IN_TEXT = new RegExp('\\d[\\d\\s\\u00a0.,]*\\s*' + CURRENCY_MARKERS, 'i');
  var PRICE_ONLY = new RegExp('^\\s*\\d[\\d\\s\\u00a0.,]*\\s*' + CURRENCY_MARKERS + '\\s*$', 'i');
  var CACHE = {};

  function hrefHandle(a) {
    var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  /*
    Dohledá produkt, ke kterému cena patří.

    Pozor na dvě pasti (obě reálně nastaly 13. 8. 2026 při testu):
    1) Karta bývá zabalená přímo do <a href="/products/...">. querySelector prohledává
       jen POTOMKY, takže takovou kartu přeskočí — proto se ptáme i na samotný uzel.
    2) Když vyšplháme až na mřížku, ta obsahuje odkazy všech karet a vzal by se první
       z nich. Všechny tři karty tak dostaly cenu Explorer 2000 V2. Proto: jakmile je
       na úrovni víc než jeden odkaz, kartu jsme minuli a raději nevrátíme nic —
       zastaralá cena je pořád lepší než sebejistě špatná.
  */
  function handleFromCard(el) {
    var explicit = el.getAttribute('data-live-price');
    if (explicit) return explicit.trim();
    for (var node = el.parentElement, hops = 0; node && hops < 8; node = node.parentElement, hops++) {
      if (node.matches && node.matches('a[href*="/products/"]')) return hrefHandle(node);
      var links = node.querySelectorAll('a[href*="/products/"]');
      if (links.length === 1) return hrefHandle(links[0]);
      if (links.length > 1) return null;
    }
    return null;
  }

  function fetchProduct(handle) {
    if (CACHE[handle]) return CACHE[handle];
    CACHE[handle] = fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'products/' + handle + '.js'
        : '/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return CACHE[handle];
  }

  /*
    Bereme cenu PRVNÍ varianty, ne product.price.

    product.price je cena NEJLEVNĚJŠÍ varianty (price_min). U Explorer 2000 Plus to je
    „Samostatná baterie" za 19 499 Kč, kdežto produktová stránka ukazuje první variantu
    „Samotná stanice" za 36 999 Kč. Použití product.price by tedy vyrobilo přesně ten
    rozpor, který tento skript odstraňuje.

    Shodné s pravidlem šablon: vždy `variants.first`, ne `selected_or_first_available_variant`
    (jinak vyprodaná samostatná varianta odskočí na set).
  */
  function priceOf(p) {
    if (!p) return null;
    if (p.variants && p.variants.length && typeof p.variants[0].price === 'number') {
      return p.variants[0].price;
    }
    return typeof p.price === 'number' ? p.price : null;
  }

  function compareOf(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    var c = p.variants[0].compare_at_price;
    return typeof c === 'number' ? c : null;
  }

  function markError(el, reason, handle) {
    el.setAttribute('data-live-price-error', reason);
    if (window.console && console.error) {
      console.error('live-prices: ' + reason + ' handle=' + (handle || 'unresolved'));
    }
  }

  // Přepíše jen textový uzel s číslem — potomky typu <small>s DPH</small> nechá být.
  function replacePriceText(el, formatted) {
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (PRICE_IN_TEXT.test(node.nodeValue)) {
        node.nodeValue = node.nodeValue.replace(PRICE_IN_TEXT, formatted);
        return true;
      }
    }
    return false;
  }

  // Srovnávací tabulky mají cenu v <td> bez třídy. Bereme jen buňku, která je celá
  // cenou, a jen v řádku odkazujícím na produkt — jinak bychom sáhli i na "~2–4 Kč/kWh".
  function tableCells() {
    var found = [];
    Array.prototype.forEach.call(document.querySelectorAll('table tr'), function (tr) {
      if (!tr.querySelector('a[href*="/products/"]')) return;
      Array.prototype.forEach.call(tr.querySelectorAll('td'), function (td) {
        if (PRICE_ONLY.test(td.textContent)) found.push(td);
      });
    });
    return found;
  }

  function run() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SEL)).concat(tableCells());
    if (!els.length) return;
    els.forEach(function (el) {
      el.setAttribute(OWNED_ATTRIBUTE, '');
      if (el.hasAttribute('data-live-price-done')) return;
      var handle = handleFromCard(el);
      if (!handle) {
        markError(el, 'product-not-found', null);
        return;
      }
      if (!window.JackeryMoney || typeof window.JackeryMoney.format !== 'function') {
        markError(el, 'formatter-missing', handle);
        return;
      }
      fetchProduct(handle).then(function (p) {
        var cents = priceOf(p);
        if (cents === null) {
          markError(el, 'product-not-found', handle);
          return;
        }
        var formatted;
        try {
          formatted = window.JackeryMoney.format(cents);
        } catch (e) {
          markError(el, 'formatter-missing', handle);
          return;
        }
        if (typeof formatted !== 'string' || !formatted.trim()) {
          markError(el, 'formatter-missing', handle);
          return;
        }
        if (replacePriceText(el, formatted)) {
          el.removeAttribute('data-live-price-error');
          el.setAttribute('data-live-price-done', '');
          // V akci = přeškrtnutá cena je vyšší než prodejní. Stejné pravidlo i stejná
          // červená (#dc2626) jako na produktové stránce (.product-page__price-current--sale).
          var cmp = compareOf(p);
          if (cmp !== null && cmp > cents) el.setAttribute('data-live-price-sale', '');
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
